import React from 'react';
import Button from '../../../../components/Button';
import FixedBottomNavBar from '../../../../components/FixedBottomNavBar';
import './SearchWordSaveNavbar.scss';

const SearchWordSaveNavbar = (props) => {
  const { isEdit, searchWordId, searchWordSave, onSubmit, removeSearchWord } = props;

  return (
    <FixedBottomNavBar className="search-word-save-navbar">
      <div className="button-group">
        <div className="left">
          {isEdit ? <Button color="gray" text="삭제하기" onClick={() => removeSearchWord(searchWordId)} /> : null}
        </div>
        <div className="right">
          <Button color="primary" text={isEdit ? '편집하기' : '등록하기'} onClick={() => onSubmit(searchWordSave)} />
        </div>
      </div>
    </FixedBottomNavBar>
  );
};

export default SearchWordSaveNavbar;
